import {
  Component,
  ChangeDetectionStrategy,
  OnChanges,
  SimpleChanges,
  Input,
  ChangeDetectorRef,
  inject,
} from '@angular/core';
import { map, Observable } from 'rxjs';

import { ReportsService } from './services';
import { GetReportForUnionResultDtoUI, ReportType } from './types';

@Component({
  selector: 'app-reports',
  templateUrl: './reports.component.html',
  styleUrls: ['./reports.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ReportsComponent implements OnChanges {
  private readonly cdr = inject(ChangeDetectorRef);
  private readonly reportsService = inject(ReportsService);

  @Input() reportType?: ReportType;
  @Input() hiddenReportData?: Object;

  reports$: Observable<Array<GetReportForUnionResultDtoUI>> | null = null;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['reportType']) {
      if (this.reportType) {
        this.reports$ = this.reportsService.getReports(this.reportType).pipe(
          map(reports =>
            reports.map(report => {
              report.hiddenReportData = this.hiddenReportData;
              return report;
            }),
          ),
        );
      } else {
        this.reports$ = null;
      }
    }

    this.cdr.markForCheck();
  }
}
